import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useDeletePack() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (packId: number) =>
      apiMutation('DELETE', {
        path: ENDPOINTS.deletePack,
        params: { id: packId.toString() },
      }) as Promise<void>,
    onSuccess: (_, packId) => {
      message.success(`Package #${packId} successfully deleted`);

      queryClient.removeQueries({
        queryKey: [CORE_QUERY_KEYS.pack, { id: packId.toString() }],
      });

      queryClient.invalidateQueries({
        queryKey: [CORE_QUERY_KEYS.packs],
      });
    },
    onError: () => {
      message.error('Failed to delete package. Package may be in use.');
    },
  });
}
